import Constants from '@/constants/const';
import { getCookie } from '@/utils/cookie';

export const showGoogleOneTap = ({
  isLogin,
  query,
  ctx,
  exp692
}: {
  isLogin: boolean;
  query: any;
  ctx?: any;
  exp692: boolean;
}) => {
  // url携带参数googleOneTap=true 不做实验，直接显示google一键登录
  const googleOneTap = query?.googleOneTap === 'true';
  // 手动选择退出
  const isOptOut = getCookie(Constants.GSOPTOUT, ctx) === '1';
  // 已登录、手动退出不显示
  if (isLogin || isOptOut) return false;
  // 未登录，url携带googleOneTap参数，显示google一键登录
  if (googleOneTap) return true;
  return exp692;
};
